module.exports = __webpack_public_path__ + "img/wggg(2).3dced7ce.jpg";